import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Modulo } from './pagine/Modulo.js';
import { Personale } from './pagine/Personale.js';
import './stili/caratteri.css';
import './stili/modulo.css';
import './stili/personale.css';

/**
 * Due porte, una applicazione.
 *
 * `/` è il modulo pubblico: aperto a chiunque, nessun accesso, deve fare una
 * cosa sola. `/staff` è l'area di chi legge le candidature, dietro password.
 *
 * Il percorso si legge una volta all'avvio, senza router: sono due schermate
 * e mezza, e una libreria di instradamento qui sarebbe più codice di quello
 * che serve.
 */
const client = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

const radice = document.getElementById('radice');
if (!radice) throw new Error('Manca il contenitore #radice in index.html');

const percorso = location.pathname.replace(/\/+$/, '');
const dentroPersonale = percorso === '/staff' || percorso.startsWith('/staff/');
const numero = Number(percorso.replace('/staff/', ''));
const idCandidatura = dentroPersonale && Number.isInteger(numero) && numero > 0 ? numero : null;

createRoot(radice).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      {dentroPersonale ? <Personale id={idCandidatura} /> : <Modulo />}
    </QueryClientProvider>
  </StrictMode>,
);
